import React from 'react'
import Table from 'react-bootstrap/Table'
import { Link } from 'react-router-dom'
import PaginationButtons from '../../../../PaginationButtons'
import { MedicationRequestTable } from '@teschglobal/tg-fhir-react-components'
import FhirLoader from '../../../../FhirLoader'
import { MedicationRequestBundle } from '../../../../../types/FHIRTypes/Bundle'
import { isMedicationRequestBundle } from '../../../../../typeGuards/fhirTypes'

type MedicationsProps = {
    medicationData: MedicationRequestBundle;
    isFetching: boolean;
    handleChangePage: (page: number) => void
    totalPages: number;
    currentPage: number;
}


const MedicationList: React.FC<MedicationsProps> = ({ medicationData, isFetching, handleChangePage, totalPages, currentPage }) => {
    if (!isMedicationRequestBundle(medicationData)) return null
    const requestedMedications = medicationData && medicationData.entry ? medicationData.entry.map((medication: any) => medication.resource) : []

    return (
        <>
            {isFetching ? (
                <FhirLoader message='Loading...' />
            ) : (
                <>
                    {
                        medicationData?.total > 0 && (
                            <div className='my-3 fw-bold'>
                                <span role="status" aria-live="polite">{medicationData?.total.toLocaleString()} record(s) found</span>
                                <PaginationButtons
                                    totalPages={totalPages}
                                    currentPage={currentPage}
                                    handleChangePage={handleChangePage}
                                />
                            </div>
                        )
                    }
                    <MedicationRequestTable medicationRequests={requestedMedications} />
                    {
                        medicationData?.total > 0 && (
                            <div className='my-3 fw-bold'>
                                <PaginationButtons
                                    totalPages={totalPages}
                                    currentPage={currentPage}
                                    handleChangePage={handleChangePage}
                                />
                            </div>
                        )
                    }
                </>
            )}
        </>
    )
}

export default MedicationList